import NextImage from "common/bit/NextImage"
import { motion, MotionValue, useScroll, useTransform } from "framer-motion"
import { useRef } from "react"
import styled from "styled-components"

const StyledMiniSectionWrapper = styled.div<{ $h?: string }>`
  height: calc(100vh - 190px);
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    #f5f5f5 0%,
    rgba(245, 245, 245, 0) 23.77%,
    rgba(245, 245, 245, 0) 44.21%,
    #f5f5f5 77.43%
  );
`
const StyledImageWrapper = styled(motion.div)`
  width: 100%;
  height: calc(100vh - 190px);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
`
const StyledAbsoluteText = styled(motion.h2)`
  margin: 0;
  font-weight: 400;
  font-size: 24px;
  position: absolute;
  text-align: center;
  line-height: 140%;
  padding: 0px 16px;
  transition: all 0.5s ease-in-out;
  background-size: 100% !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  color: ${(p) => p.theme.colors.transparent};
  transform-origin: 0%;
  width: 320px;
`

type SafetyParallaxProps = {
  text: string
  y: MotionValue<number>
  top?: number
}

function useBackroundChange(value: MotionValue<number>) {
  // value,
  // Map x from these values:[0, 1],
  // Into these values:
  //  [-distance, distance]
  return useTransform(
    value,
    [0, 0.5],
    [
      "linear-gradient(4.83deg, #000000 -293.68%, rgba(255, 255, 255, 0) -67.38%)",
      "linear-gradient(82.94deg, #000000 -0.17%, rgba(255, 255, 255, 0) 219.49%)",
    ]
  )
}

const SafetyParallaxTwo = ({ text, y }: SafetyParallaxProps) => {
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["end", "start"],
  })
  const background = useBackroundChange(scrollYProgress)
  return (
    <StyledMiniSectionWrapper ref={ref}>
      {[1, 2, 3, 4, 5].map((i) => (
        <StyledImageWrapper
          style={{ y }}
          key={`paralex=${i}`}
          transition={{ type: "spring" }}
        >
          <NextImage
            image={{
              imageUrl: "/img/road-stripes.png",
              alt: "road-stripes",
            }}
            cover={false}
            imageSizes={["100vw", "384px"]}
            role="presentation"
            aria-hidden="true"
          />
        </StyledImageWrapper>
      ))}
      <StyledAbsoluteText
        style={{
          background,
        }}
      >
        {text}
      </StyledAbsoluteText>
    </StyledMiniSectionWrapper>
  )
}

export default SafetyParallaxTwo
